import {
  Injectable,
  signal,
  WritableSignal,
  inject,
  effect,
} from '@angular/core';
import { ResponsiveService } from '@/app/core/services/responsive.service';

const LOCAL_STORAGE_KEY = 'collapsible_states';

@Injectable({
  providedIn: 'root',
})
export class CollapsibleService {
  private responsiveService = inject(ResponsiveService);
  protected data: Map<string, WritableSignal<boolean>> = new Map();

  public isMobile: WritableSignal<boolean> = signal(
    this.responsiveService.isMobile()
  );
  public isMobileOpen: WritableSignal<boolean> = signal(false);

  constructor() {
    const state = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (state) {
      const parsedState: { [key: string]: boolean } = JSON.parse(state);
      // eslint-disable-next-line guard-for-in
      for (const key in parsedState) {
        this.data.set(key, signal(parsedState[key]));
      }
      effect(() => {
        // const bp = this.responsiveService.currentBreakpoint();
        const isMobile = this.isMobile();
        const isNowMobile = this.responsiveService.isMobile();
        if (!isMobile && isNowMobile) {
          console.log('collapsible.service setting isMobileOpen to false ');
          this.isMobile.set(true);
          this.isMobileOpen.set(false);
        }

        if (!isNowMobile && isMobile) {
          console.log(
            'collapsible.service setting isMobileOpen to false on desktop '
          );
          this.isMobile.set(false);
          this.isMobileOpen.set(false);
        }
        console.log('collapsible.service breakpoint effect ', isMobile);
      });
    }
  }

  toggle(key: string): boolean | null {
    console.log('collapsible.service.toggle  ', key);
    if (this.responsiveService.isMobile()) {
      const isMobileOpen = this.isMobileOpen();
      console.log('collapsible.service.toggle  before', isMobileOpen);
      this.isMobileOpen.set(!isMobileOpen);
      console.log('collapsible.service.toggle  after', this.isMobileOpen());
      console.log(
        'collapsible.service.toggle ',
        isMobileOpen,
        this.isMobileOpen()
      );
    } else {
      console.log('collapsible.service.toggle  ', key);
      const state = this.getState(key);
      state.set(!state());
      this.saveToLocalStorage();
      console.log('collapsible.service.toggle  after', state());
      return state();
    }
  }

  registerCollapsible(key: string, initialState: boolean = false): void {
    if (!this.data.has(key)) {
      this.data.set(key, signal(initialState));
    }
    this.saveToLocalStorage();
  }

  getState(key: string): WritableSignal<boolean> {
    let state = this.data.get(key);
    if (!state) {
      // Create a new signal if one doesn't exist for this key
      state = signal(false);
      this.data.set(key, state);
    }
    return state;
  }

  private saveToLocalStorage(): void {
    const stateToSave: { [key: string]: boolean } = {};
    this.data.forEach((value, key) => {
      stateToSave[key] = value();
    });
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(stateToSave));
  }
}
